export const CHILDREN_SIGNUP_REPORT = 'CHILDREN_SIGNUP_REPORT'
export const CHILDREN_SIGNUP_REPORT_SUCCESS = 'CHILDREN_SIGNUP_REPORT_SUCCESS'
export const CHILDREN_SIGNUP_REPORT_FAILED = 'CHILDREN_SIGNUP_REPORT_FAILED'

export const CLEAR_CHILDREN_SIGNUP_REPORT = 'CLEAR_CHILDREN_SIGNUP_REPORT'
